import styled from 'styled-components';

export const LiteTradeNotificationStyled = styled.div`
    position: relative;
    touch-action: none;
    
    .basic-info__side {
        color: var(--color-label-secondary);
    }
`;

export const LiteTradeNotificationStatusIconContainerStyled = styled.div`
    display: flex;
    padding: 4px;
    border-radius: 8px;
    &.success {
        background-color: var(--color-fill-positive);
        svg {
            fill: var(--color-label-positive);
        }
    }
    &.warning {
        background-color: var(--color-fill-secondary);
        svg {
            fill: var(--color-label-secondary);
        }
    }
    &.attention {
        background-color: var(--color-fill-negative);
        svg {
            fill: var(--color-label-negative);
        }
    }
`;

export const LiteTradeNotificationAccountTypeStyled = styled.div`
    padding: 2px 8px;
    border-radius: 8px;
    background-color: #8192E41A;
    color: var(--color-label-secondary);
    font-size: 12px;
`;

export const LiteTradeNotificationAccountTypeContainerStyled = styled.div`
    display: flex;
    &.with-close-button {
        padding-right: 32px;
    }
`;

export const LiteTradeNotificationDescriptionStyled = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: var(--color-label-secondary);
`;
